<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="handleBackHomeButton" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister  @saveChange="saveChanges">
            <div class="col-12 mt-4">
                <div class="width-650 d-flex align-items-start justify-content-between">
                    <div class="col-12 px-0">
                        <div class="d-flex justify-content-between mb-2">
                            <h4 class="c-ndarkfour regular break pb-0 mb-0" v-html="title"></h4>
                            <h6 class="c-sredfour regular text-nowrap">*Documentos obrigatórios</h6>
                        </div>
                        <h6 class="c-ndarkfour regular mt-0 pt-0">
                            {{ subtitle }}
                            <!--
                            <p class="c-nmidone regular mt-2 px-0 col-4" v-if="enableComplementaryRegister && !$store.state.user.userAdm && !USER_TYPE_MIXIN.isBackOffice">
                                <HelpZipFiles />
                            </p>
                            -->
                        </h6>
                        <h6 v-if="isProvider" slot="tip" class="c-nmidone regular">
                            Formatos aceitos: .pdf, .jpeg, .png, .doc. <br> Tamanho máximo: 30 MB.
                        </h6>
                    </div>
                    <!--
                    <div class="col-2 mr-3 p-0" v-if="!$store.state.user.userAdm && enableComplementaryRegister && getWhiteLabel == 'CASHFORCE'">
                        <Button @click="downloadDocumentsCompany()" type="outline" class="px-2 download-docs-btn" :color="getPrimaryColor">
                            <Download size="10" :color="getPrimaryColorHex.four" />
                            Baixar fichas
                        </Button>
                    </div>
                    -->
                </div>
            </div>
            <div class="col-10 mt-4" v-if="!$store.state.user.userAdm && !USER_TYPE_MIXIN.isBackOffice && !$route.path.includes('company')">
                <p class="c-ndarkfour bold mb-1">Você vai precisar de:</p>
                <DocumentsChecklist :complementaryRegister="enableComplementaryRegister"/>
            </div>
            <div class="col-12 mt-4">
                <Upload
                    ref="fileUpload"
                    modalForExclude
                    @removeFile="handleDeleteDocument($event, true)"
                    v-if="(!blockInputs || enableComplementaryRegister) && !isProvider"
                    :fileSize="30" :limit="100" accept=" .pdf, .jpeg, .png, .doc, .xml"
                    v-model="fileList"
                    multiple
                    @change="handleChange"
                    class="mb-n4"
                    :uploadKey="childKey"
                >
                    <div slot="checklist">                        
                        <p class="c-ndarkfour medium mb-2 mt-4" v-if="fileList.length || downloadedFileList.length">Documentos anexados</p>
                    </div>
                </Upload>

                <div class="main-documents-list" v-if="isProvider">
                    <div class="d-flex align-items-center justify-content-between list-upload" v-for="(doc, index) in documentsList" :key="index">
                        <div class="d-flex align-items-center mb-1 mt-1">
                            <File />
                            <p class="doc-title c-ndarkfour ml-2 mr-2">{{ doc.title }}<span v-if="doc.isRequired" class="c-sredfour regular">*</span> 
                                <el-tooltip class="ml-1" placement="bottom" v-if="doc.hasTooltip">
                                    <div slot="content" style="text-align: center" v-html="doc.tooltipText"></div>
                                    <Interrogation />
                                </el-tooltip>
                            </p>
                        </div>
                        <el-upload
                                class="upload-demo"
                                action="null"
                                :auto-upload="false"
                                :fileSize="30" 
                                :limit="100"
                                multiple
                                :show-file-list="false"
                                :file-list="fileList"
                                :on-change="handleChangeUploadBtn"
                                accept=".pdf, .jpeg, .png, .doc"
                        >
                                <Button v-if="!blockInputs" type="outline" class="small" :color="getPrimaryColor" @click="handleDocumentType(doc.type)">
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 6.33203V8.10972C9 8.34545 8.90635 8.57153 8.73965 8.73822C8.57295 8.90491 8.34686 8.99856 8.11111 8.99856H1.88889C1.65314 8.99856 1.42705 8.90491 1.26035 8.73822C1.09365 8.57153 1 8.34545 1 8.10972V6.33203" :stroke="getPrimaryColor" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7.22179 3.22211L4.99957 1L2.77734 3.22211" :stroke="getPrimaryColor" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M5 1V6.33306" :stroke="getPrimaryColor" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <span>Anexar</span>
                                </Button>
                        </el-upload>
                    </div>
                </div>
                
                <div>
                    <div slot="checklist">                        
                        <p class="c-ndarkfour medium mb-2 mt-4" v-if="(fileList.length || downloadedFileList.length) && isProvider">Documentos anexados</p>
                    </div>
                    <div class="attachedDocumentsBox">
                        <span :class="`d-flex align-items-center justify-content-between list-upload mt-0 mb-4 ${docHaveType(file)}`" v-for="(file, index) in renderDocumentList" :key="index">

                            <div class="d-flex align-items-center w-75">
                                <File />
                                <div class="w-75">
                                    <p 
                                        v-if="file.documentTypeId !== undefined && file.documentTypeId !== null" 
                                        class="doc-title bold c-ndarkfour ml-4 mb-0"
                                    >
                                        {{ renderDocumentType(file) }}
                                    </p>
                                    <p class="doc-title c-ndarkfour ml-4 mb-0 mt-0">
                                        {{ fileName(file) }} <span v-if="file.size" class="c-nmidfour">{{ renderFileSize(file) }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <!-- UPDATE -->
                                <Button v-if="($store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice) && !file.documentTypeId" icon color="grey" type="outline" @click="updateDocumentType(file)" >
                                    <Teste class="mr-0" color="#727D94" size="16" />
                                </Button>

                                <!-- EYE -->
                                <Button icon color="grey" class="ml-2" type="outline" @click="previewFile(file)" >
                                    <Eye class="mr-0" color="#727D94" size="16" />
                                </Button>

                                <!-- DELETE -->
                                <Button v-if="!blockInputs && file.id" class="ml-2" icon color="red" type="outline" @click="handleDeleteDocument(file.id)">
                                    <Trash color="#E54949" size="16" />
                                </Button>
                                <Button v-else-if="!blockInputs && !file.id" class="ml-2" icon color="red" type="outline" @click="handleDeleteDocumentModal(file)">
                                    <Trash color="#E54949" size="16" />
                                </Button>
                            </div>

                        </span>
                    </div>
                </div>
            </div>
            <!--
            <div class="col-12">
                <DocumentsChecklistCashforce @checklistUpdate="documentsChecklist = $event"/>
            </div>
            -->
            <div class="col-12 mt-3" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">
                <h6 class="c-ndarkfour regular">Observação</h6>
                <el-input  type="textarea"  :class="`${getPrimaryColor} width-650 document-review`" v-model="documentReview" maxlength="5000"></el-input>
                <h6 class="regular mt-1 pl-2 ml-1"> <b> {{ charCount }} </b> caracteres restantes.</h6>
            </div>
            <div class="col-12 d-flex align-items-center mb-4 mt-5">
                <RegisterNavigationButtons
                    class="px-0"
                    v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice"
                    @backStep="backStep"
                    @nextStep="handleNextButton"
                    @saveChange="saveChanges"
                />
                <div v-else>
                    <Button @click="handleBackButton" class="mr-4 px-3" type="outline" :color="getPrimaryColor">
                        <ArrowDropdown :rotate="90" :color="getPrimaryColorHex.four"/>
                        Voltar
                    </Button>
                    <Button
                        :color="getPrimaryColor"
                        :disabled="!blockInputs && !$store.state.user.userAdm && attachedRequiredDocuments"
                        @click="handleNextButton"
                    >
                    {{$store.state.register.company.cnpj.companyType != '1' ? 'Finalizar' : buttonUserTitle }}
                </Button>
                </div>
            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="handleCloseModal" @cancelRegister="backStep" @saveChange="saveChanges"/>
    <CheckDocuments :dialogVisible="dialogCheckVisible && !isProvider" :complementaryRegister="enableComplementaryRegister" @closeModal="dialogCheckVisible = false" @confirm="saveChanges"/>
    <DocumentDelete :dialogVisible="dialogDeleteVisible" @closeModal="dialogDeleteVisible = false" @confirmDelete="removeFile"/>
    <RegisterCompleted v-if="!$route.path.includes('partner')" :dialogVisible="dialogRegisterVisible" @closeModal="handleRegisterModal"/>
    <RegisterCompletedPartner v-if="$route.path.includes('partner')" :dialogVisible="dialogRegisterVisible" @closeModal="handleRegisterModal"/>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
    <ConfirmRegisterChange :dialogVisible="dialogRegisterChangeVisible" :complementaryRegister="enableComplementaryRegister" @closeModal="dialogRegisterChangeVisible = false"/>
    <OverwriteFile :dialogVisible="dialogVisibleOverwrite" @closeModal="handleChange(fileList); dialogVisibleOverwrite = false " @overwriteFile="overwriteFile"/>
    <UpdateDocumentType :dialogVisible="dialogUpdateDocumentType" :documentsList="documentsList" @closeModal="dialogUpdateDocumentType = false" @updateDocumentType="handleUpdateDocumentType"/>
    <DocumentDelete :dialogVisible="dialogDeleteLocalVisible" @closeModal="dialogDeleteLocalVisible = false" @confirmDelete="handleDeleteLocalDocument"/>
</div>
</template>

<script>
import RegisterHeader from '@/components/register/RegisterHeader'
//import HelpZipFiles from '@/components/register/HelpZipFiles'
import Trash from '@/components/icons/Trash'
import Eye from '@/components/icons/Eye'
import Teste from '@/components/icons/Rotate'
//import Download from '@/components/icons/Download'
import File from '@/components/icons/File.vue'
import Interrogation from '@/components/icons/Interrogation.vue'
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import CancelRegister from '@/components/modals/CancelRegister'
import BoxRegister from '@/components/box/BoxRegister'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import insertCompanyDocuments from '@/api/insertCompanyDocuments'
import insertPartnerPJDocuments from '@/api/insertPartnerPJDocuments'
import insertPartnerPFDocuments from '@/api/insertPartnerPFDocuments'
import getCompanyDocuments from '@/api/getCompanyDocuments'
import getPartnerPFDocuments from '@/api/getPartnerPFDocuments'
import getPartnerPJDocuments from '@/api/getPartnerPJDocuments'
import deleteCompanyDocument from '@/api/deleteCompanyDocument'
import DocumentDelete from '@/components/modals/DocumentDelete'
import CheckDocuments from '@/components/modals/CheckDocuments'
import RegisterCompleted from '@/components/modals/RegisterCompleted'
import RegisterCompletedPartner from '@/components/modals/RegisterCompletedPartner'
import UpdateDocumentType from '@/components/modals/UpdateDocumentType.vue'
import DocumentsChecklist from '@/components/register/DocumentsChecklist'
import statusCodesBlockInput from '@/utils/statusCodesBlockInput'
import FullLoading from '@/components/loading/FullLoading'
import updatePartnerPF from '@/api/updatePartnerPF'
import updatePartnerPJ from '@/api/updatePartnerPJ'
import updateCompany from '@/api/updateCompany'
import updatePartnerPFChecklist from '@/api/updatePartnerPFChecklist'
import updatePartnerPJChecklist from '@/api/updatePartnerPJChecklist'
import ConfirmRegisterChange from '@/components/modals/ConfirmRegisterChange'
//import DocumentsChecklistCashforce from '@/components/register/DocumentsChecklistCashforce'
import RegisterNavigationButtons from '@/components/register/RegisterNavigationButtons'
import updateRegisterStep from '../../api/updateRegisterStep'
import Vue from 'vue'
import OverwriteFile from '@/components/modals/OverwriteFile'
import updateCompanyDocument from '@/api/updateCompanyDocument'
import updateDocumentType from '@/api/updateDocumentType'
import documentsList from '../../utils/documentsList'
import getWhiteLabel from '../../utils/getWhiteLabel'


export default {
    components: {
        //HelpZipFiles,
        Trash,
        Eye,
        //Download,
        //CompanyTypeStatus,
        CancelRegister,
        BoxRegister,
        ArrowDropdown,
        DocumentDelete,
        DocumentsChecklist,
        //DocumentsChecklistCashforce,
        RegisterHeader,
        CheckDocuments,
        RegisterCompleted,
        RegisterCompletedPartner,
        FullLoading,
        ConfirmRegisterChange,
        RegisterNavigationButtons,
        OverwriteFile,
        File,
        Interrogation,
        Teste,
        UpdateDocumentType,
    },
    data() {
        return {
            dialogDeleteVisible: false,
            dialogDeleteLocalVisible: false,
            dialogUserVisible: false,
            dialogCheckVisible: false,
            backToCompanyHome: false,
            dialogRegisterVisible: false,
            dialogRegisterChangeVisible: false,
            dialogVisible:false,
            dialogUpdateDocumentType: false,
            documents: [],
            fileList: [],
            downloadedFileList: [],
            documentToDeleteId: '',
            documentsChecklist: {},
            documentReview: '',
            documentToDeleteIsLocal: false,
            dialogVisibleOverwrite: false,
            childKey: 0,
            documentTypeId: 0,
            newDocumentType: {
                id: 0,
                type: 0,
            },
            typeUpdatedFiles: [],
            fileToDelete: {},
        }
    },
    computed: {
        charCount() {            
            return 5000 - (this.documentReview.length || 0)
        },
        title() {
            const { path } = this.$route
            if (path.includes('partner')) {
                const partnerName = this.$options.filters.formatName(this.$store.state.register.partner.name)
                if (path.includes('pf')) return `<strong>Documentos do sócio</strong> | ${partnerName}`
                if (path.includes('pj')) return `<strong>Documentos do sócio PJ</strong> | ${partnerName}`
                return `<strong>Documentos do procurador</strong> | ${partnerName}`
            }
            return '<strong>Documentos</strong>'
        },
        subtitle() {
            const { path } = this.$route
            if (path.includes('partner')) {
                if (path.includes('pf') || path.includes('pj')) {
                    if (this.enableComplementaryRegister) return 'Faça o upload dos documentos do sócio de acordo com a modalidade escolhida:'
                    return `Faça o upload dos documentos do sócio de acordo com a lista abaixo`
                }
                return `Faça o upload dos documentos do procurador de acordo com a lista abaixo`
            } else {
                if (path.includes('company')) {
                    // if (this.enableComplementaryRegister) return 'Faça o upload dos documentos da empresa de acordo com a modalidade escolhida:'
                    return 'Faça o upload dos documentos da empresa de acordo com a lista abaixo'
                }
                // if (this.USER_TYPE_MIXIN.isBackOffice) return 'Visualize todos os documentos de cadastro (balanço, etc).'
                if (path.includes('buyer')) return 'Faça o upload de todos os documentos de cadastro do comprador (balanço, etc).'
                if (path.includes('sponsor')) return 'Faça o upload de todos os documentos de cadastro do financiador (balanço, etc).'
                return 'Faça o upload dos documentos da empresa ou confira os documentos já enviados'
            }
        },
        blockInputs() {
            const hasStatus = statusCodesBlockInput.includes(this.$store.state.user.registerComplete)
            return (!this.$store.state.user.userAdm && !this.USER_TYPE_MIXIN.isBackOffice && hasStatus)
        },
        buttonUserTitle() {
            return this.blockInputs && !this.$store.state.register.formIsChanged ? 'Continuar' : 'Salvar e continuar'
        },
        nextPartners() {
            const partners = this.$store.state.register.partners.filter(partner => partner.id != this.$route.params.id && (!partner.associateType || partner.associateType != 'Procurador') && partner.registerComplete == 0)
            return partners
        },
        enableComplementaryRegister() {
            //return !this.$store.state.user.userAdm
            //&& this.$store.state.user.companyType == '1'
            //&& this.$store.state.register.company.cnpj.registerComplete == 1
            //&& !this.$store.state.register.company.cnpj.complementaryRegister
            return false
        },
        nextPartnerComplementary() {
            const partner = this.$store.state.register.partners.find(partner => partner.id != this.$route.params.id && (!partner.associateType || partner.associateType != 'Procurador') && partner.registerComplete == 1 && !partner.sentComplementaryDocs)
            return partner
        },
        documentsList() {
            let route = ''
            let isPartnerMarried = this.$store.state.register.partner?.currentlyMarried

            if (this.isProvider) route += 'company'
            if (this.$route.path.includes('partner')) route += 'Partner'
            if (this.$route.path.includes('pj')) route += 'Pj'
            if (this.$route.path.includes('procurator')) route += 'Procurator'
            if (getWhiteLabel(true) === 'carbon') route += 'Carbon'
            if (getWhiteLabel(true) === 'universo') route += 'Universo'

            if (!isPartnerMarried && !this.$route.path.includes('procurator') && this.isProvider) {
                return documentsList[route].filter(d => !(d.title === 'Certidão de casamento (se aplicável)'))
            }

            return documentsList[route]
        },
        renderDocumentList() {
            if(this.isProvider) {
                const listOne = this.fileList
                const listTwo = this.downloadedFileList
                return listOne.concat(listTwo)
            }
            return this.downloadedFileList
        },
        isProvider() {
            return this.$store.state.register.company.cnpj.companyType == 1
        },
        attachedRequiredDocuments() {
            if (this.isProvider) {
                const requiredDocs = this.documentsList.filter(dl => dl.isRequired )
                const attachedDocs = this.renderDocumentList.map(d => d.documentTypeId)
                const validateDocs = requiredDocs.filter(rd => !attachedDocs.includes(rd.type)).length > 0

                return validateDocs
            }
            
            return true
        }
    },
    watch: {
        /* company: {
            deep: true,
            handler() {
                if (!this.$store.state.register.formIsChanged) {
                    this.$store.commit('register/setFormIsChanged', true)

                }                
            }
        } */
        /* documentReview() {
            if (!this.$store.state.register.formIsChanged) {
                this.$store.commit('register/setFormIsChanged', true)
            } 
        }, */
        documents() {
            if (!this.$store.state.register.formIsChanged) {
                this.$store.commit('register/setFormIsChanged', true)
            }  
        },
        $route: async function() {
            await this.getDocuments()
            await this.getDocumentReview()
            this.$store.commit('register/setFormIsChanged', false)
        }
    },
    methods: {
        handleCloseModal() {
            this.dialogVisible = false
            this.backToCompanyHome = false
        },
        handleBackButton() {
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        handleBackHomeButton() {
            this.backToCompanyHome = true
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        handleDeleteDocumentModal(file) {
            this.dialogDeleteLocalVisible = true
            this.fileToDelete = file
        },
        handleDeleteDocument(id, localDocument = false) {
            this.dialogDeleteVisible = true
            this.documentToDeleteId = id
            this.documentToDeleteIsLocal = localDocument
        },
        async handleDeleteLocalDocument() {
            const file = this.fileToDelete
            const newFileList = this.fileList.filter(f => f.uid != file.uid)
            this.fileList = newFileList

            const newBase64List = await Promise.all(newFileList.map(async file => {
                const base64File = await this.toBase64(file.raw)
                const base64Header = base64File.indexOf(',') + 1
                const fileData = {
                    documentTypeId: file.documentTypeId,
                    name: file.name,
                    file: base64File.slice(base64Header , base64File.length),
                }
                return fileData
            }))

            this.documents = newBase64List
            this.dialogDeleteLocalVisible = false
        },
        previewFile(file) {
            if(file.path) {
                window.open(`${process.env.VUE_APP_ROOT_API}/${file.path}`)
            }
            let fileURL = URL.createObjectURL(file.raw);
            window.open(fileURL);
        },
        async removeFile() {
            if (this.documentToDeleteIsLocal) {
                this.$refs.fileUpload.removeFile(this.documentToDeleteId);
            } else {
                const result = await deleteCompanyDocument(this.documentToDeleteId)
                if (result.data.ok) {
                    await this.getDocuments()
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }
            this.documentToDeleteIsLocal = false
            this.documentToDeleteId = ''
            this.dialogDeleteVisible = false
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleChangeUploadBtn(file, fileList) {
            const downloadedFileNames = this.downloadedFileList.map(({ originalFileName }) => originalFileName)

            const newFileList = fileList.map(file => {
                return {
                    ...file,
                    exists: downloadedFileNames.includes(file.name),
                    documentTypeId: file.documentTypeId ?? this.documentTypeId
                }
            })

            this.fileList = newFileList

            const newBase64List = await Promise.all(newFileList.map(async file => {
                const base64File = await this.toBase64(file.raw)
                const base64Header = base64File.indexOf(',') + 1
                const fileData = {
                    documentTypeId: file.documentTypeId,
                    name: file.name,
                    file: base64File.slice(base64Header , base64File.length),
                }
                return fileData
            }))

            this.documents = newBase64List
        },
        async handleChange(fileList, overWrite = false) {
            const downloadedFileNames = this.downloadedFileList.map(({ originalFileName }) => originalFileName)
            
            this.fileList = fileList.map(file => {
                return {
                    ...file,
                    exists: downloadedFileNames.includes(file.name)
                }
            })

            if (!overWrite) {

                if (this.fileList.some((file) => file.exists && !this.documents.map(({ name }) => name).includes(file.name))) {
                    this.dialogVisibleOverwrite = true
                    return
                }


            }
            
            const base64List = await Promise.all(fileList.map(async file => {
                const base64File = await this.toBase64(file.raw)
                const base64Header = base64File.indexOf(',') + 1
                const toOverwrite = overWrite && file.exists
                const fileData = {
                    name: file.name,
                    file: base64File.slice(base64Header , base64File.length),
                    toOverwrite,
                    id: toOverwrite ? this.downloadedFileList.find(({ originalFileName }) => originalFileName === file.name).id : undefined
                }
                return fileData
            }))
            this.documents = base64List
        },
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        async saveChanges() {
            let result = true
            this.dialogCheckVisible = false
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                const resultChecklistAndReview = this.$route.path.includes('procurator') || this.$route.path.includes('pf')
                        ? await Promise.all([
                            await updatePartnerPFChecklist(this.$route.params.id, this.documentsChecklist),
                            await updatePartnerPF(this.$route.params.id, { documentReview: this.documentReview })
                        ])
                        : this.$route.path.includes('pj') ? Promise.all([ 
                            await updatePartnerPJChecklist(this.$route.params.id, this.documentsChecklist),
                            await updatePartnerPJ(this.$route.params.id, { documentReview: this.documentReview })
                        ])
                        : await updateCompany(this.$route.params.idCNPJ, { ...this.documentsChecklist, documentReview: this.documentReview })
                const resultChecklist = resultChecklistAndReview.length > 1 ? resultChecklistAndReview[0] : resultChecklistAndReview
                if (resultChecklist.ok) {
                    if (!this.$route.path.includes('partner')) {
                        this.$store.commit('register/setCompany',  { ...this.documentsChecklist, documentReview: this.documentReview })
                    } else {
                        this.$store.commit('register/setPartner', { associateDocumentsCheckList:  this.documentsChecklist, documentReview: this.documentReview })
                    }
                }
            }
            
            if (this.fileList.length) {
                const documentsRequestsResult = await Promise.all(this.documents.map(async file => {
                    return this.$route.path.includes('procurator') || this.$route.path.includes('pf')
                        ? await insertPartnerPFDocuments({ associatePfId: this.$route.params.id, documentTypeId: file.documentTypeId, files: file })
                        : this.$route.path.includes('pj')
                            ? await insertPartnerPJDocuments({ associatePjId: this.$route.params.id, documentTypeId: file.documentTypeId, files: file })
                            : file.toOverwrite
                                ? await updateCompanyDocument({ cnpjId: this.$route.params.idCNPJ, ...file })
                                : await insertCompanyDocuments({ cnpjId: this.$route.params.idCNPJ, documentTypeId: file.documentTypeId, files: file })
                }))
                result = documentsRequestsResult.every(result => result.ok == true)
                this.reloadUpload()
            }

            if (this.typeUpdatedFiles.length) {
                const documentsRequestsResult = await Promise.all(this.typeUpdatedFiles.map(async file => {
                    return await  updateDocumentType({id: file.id, documentTypeId: file.type })
                }))
                result = documentsRequestsResult.every(result => result.ok == true)
                this.reloadUpload()
            }


            if (result) {
                this.$notify({
                    title: 'Dados salvos com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
                if (!this.enableComplementaryRegister) {
                    await updateRegisterStep(this.$route.params.idCNPJ, { step: 5 })
                }
                this.$store.commit('register/setFormIsChanged', false)
                this.fileList = []
                if (!this.$store.state.user.userAdm) {
                    return this.nextStep()
                }
                this.documents = []
                await this.getDocuments()

            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        async nextStep() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                const companyType = this.$store.state.register.company.cnpj.companyType
                const route = companyType == 1 ? `/partner/${this.$route.params.idCNPJ}` : companyType == 2 ? `/buyer/${this.$route.params.idCNPJ}/contract` : `/company/${this.USER_TYPES_MIXIN[companyType]}`
                this.$router.push(route)
            } else {
                const partnerRoute = `/company/register/${this.$route.params.idCNPJ}/partner`
                if (this.$route.path.includes('partner') && !this.blockInputs) {
                    if (this.$route.path.includes('pj')) await updatePartnerPJ(this.$route.params.id, { registerComplete: 1 })
                    else await updatePartnerPF(this.$route.params.id, { registerComplete: 1 })
                }
                if (this.$route.path.includes('partner') && this.enableComplementaryRegister && this.$store.state.register.partner.registerComplete == 1 && this.blockInputs) {
                    if (this.nextPartnerComplementary) {
                        const partners = this.$store.state.register.partners.map((partner) => {
                            if (partner.id == this.$store.state.register.partner.id) {
                                partner.sentComplementaryDocs = true
                                return partner
                            } else {
                                return partner
                            }
                        })
                        this.$store.commit('register/setPartners', partners)
                        this.$store.commit('register/setPartner', this.nextPartnerComplementary)
                        this.$refs.fileUpload.value = []
                        return this.nextPartnerComplementary.associateType == 'Sócio' ? this.$router.push(`${partnerRoute}/pf/${this.nextPartnerComplementary.id}/1`) : this.$router.push(`${partnerRoute}/pj/${this.nextPartnerComplementary.id}/2`)
                    }
                    return this.dialogRegisterChangeVisible = true
                }
                if (this.blockInputs || this.$route.query.new) {
                    if (this.enableComplementaryRegister && !this.$route.path.includes('partner')) {
                        return this.$router.push(`${partnerRoute}/message`)
                    }
                    this.$router.push(`${partnerRoute}`)
                } else if (!this.$route.path.includes('partner') || this.nextPartners.length) {
                    this.dialogRegisterVisible = true                    
                } else {
                    this.dialogRegisterChangeVisible = true
                }
            }
        },
        handleNextButton() {
            if (this.$store.state.user.userAdm || this.blockInputs && !this.$store.state.register.formIsChanged || this.USER_TYPE_MIXIN.isBackOffice) {
                this.nextStep()
                this.fileList = []
            } else if (this.$route.path.includes('company')) {
                this.saveChanges()
            } else {
                this.dialogCheckVisible = true
            }
        },
        backStep() {
            const { path, params } = this.$route
            const companyType = this.$store.state.register.company.cnpj.companyType
            const companyName = this.USER_TYPES_MIXIN[companyType]
            const isBackOffice = this.USER_TYPE_MIXIN.isBackOffice

            const routeType = path.includes('partner') ? 'partner'
                : path.includes('update') ? 'update'
                : 'register'

            const routeCompany = path.includes('pf') ? 'pf'
                : path.includes('pj') ? 'pj'
                : path.includes('procurator') ? 'procurator'
                : path.includes('buyer') ? 'buyer'
                : path.includes('sponsor') ? 'sponsor'
                : path.includes('provider') ? 'provider'
                : 'company'

            const routeStep = path.includes('pf') || path.includes('procurator') ? '0'
                : path.includes('pj') ? '1'
                : path.includes('provider') && !isBackOffice ? '3'
                : path.includes('buyer') || path.includes('sponsor') || path.includes('company') || path.includes('provider') && isBackOffice ? '2'
                : '0' 

            const route = this.backToCompanyHome ? `/company/${companyName}`
                : path.includes('partner') && path.includes('company') ? `/company/register/${params.idCNPJ}/partner/${routeCompany}/${params.id}/${routeStep}`
                : path.includes('partner') && !path.includes('company') ? `/${routeType}/${params.idCNPJ}/${routeCompany}/${params.id}/${routeStep}`
                : `/${routeCompany}/${routeType}/${params.idCNPJ}/${routeStep}`
                
            this.$router.push(route)
        },
        async getDocuments() {
            const result = this.$route.path.includes('procurator') || this.$route.path.includes('pf') ? await getPartnerPFDocuments(this.$route.params.id)
                : this.$route.path.includes('pj') ? await getPartnerPJDocuments(this.$route.params.id)
                : await getCompanyDocuments(this.$route.params.idCNPJ)
            this.downloadedFileList = result.data.payload
        },
        downloadDocumentsCompany() {
            if (this.$route.path.includes('partner')) {
                window.open('https://files.cashforce.com.br/fichas-cadastrais-socios.zip')
            } else {
                window.open('https://files.cashforce.com.br/fichas-cadastrais-empresa.zip')
            }
        },
        getDocumentReview() {
            const registerDocumentReview = this.$route.path.includes('partner') ? this.$store.state.register.partner.documentReview : this.$store.state.register.company.documentReview
            this.documentReview = registerDocumentReview != null ? registerDocumentReview : ''
        },
        overwriteFile() {
            this.handleChange(this.fileList, true)
            this.dialogVisibleOverwrite = false
        },
        reloadUpload() {
            // Incrementando a chave para forçar o recarregamento
            this.childKey += 1
        },
        fileName(file) {
            const name = file.originalFileName ? file.originalFileName : file.name
            return name
        },
        handleDocumentType(type) {
            this.documentTypeId = type
        },
        renderDocumentType(file) {
            let route = ''

            if (this.isProvider) route += 'company'
            if (this.$route.path.includes('partner')) route += 'Partner'
            if (this.$route.path.includes('pj')) route += 'Pj'
            if (this.$route.path.includes('procurator')) route += 'Procurator'
            if (getWhiteLabel(true) === 'carbon') route += 'Carbon'
            if (getWhiteLabel(true) === 'universo') route += 'Universo'

            let typeTitle = documentsList[route].
                            find(dp => dp.type == file.documentTypeId).title.replace('(se houver)', '')
            return typeTitle
        },
        docHaveType(file) {
            if(file.documentTypeId || this.$route.path.includes('company')) {
                return ''
            }
            return 'no-type-doc'
        },
        renderFileSize(file) {
            const fileSize = (parseInt(file.size) / 1000000).toFixed(2)
            return `(${fileSize} MB)`
        },
        updateDocumentType(file) {
            const fileIdentifier = file.id ? file.id : file.uid
            
            this.newDocumentType.id = fileIdentifier
            this.dialogUpdateDocumentType = true
        },
        handleUpdateDocumentType(type) {
            this.newDocumentType.type = type
            
            const isLocalFile = this.fileList.some(f => f.uid == this.newDocumentType.id)

            if(isLocalFile) {
                this.fileList = this.fileList.map(f => {
                    if(f.uid == this.newDocumentType.id) {
                        return {
                            ...f,
                            documentTypeId: this.newDocumentType.type,
                        }
                    }
                    return f
                })
                this.handleChangeUploadBtn(undefined, this.fileList)
            } else {
                const newFileUpdated = this.downloadedFileList.find(f => f.id == this.newDocumentType.id)
                newFileUpdated.documentTypeId = this.newDocumentType.type
                const registeredUpdatedFile = this.typeUpdatedFiles.find(uf => uf.id == this.newDocumentType.id)

                if(registeredUpdatedFile) {
                    registeredUpdatedFile.type = this.newDocumentType.type
                } else {
                    this.typeUpdatedFiles.push({...this.newDocumentType})
                }
            } 
        },
        async handleRegisterModal() {
            await this.getDocuments()
            this.dialogRegisterVisible = false
        }
    },
    async created() {
        await this.getDocuments()
        this.getDocumentReview()
        this.$store.commit('register/setFormIsChanged', false)
    },
    mounted() {
        Vue.nextTick(() => {
            this.$store.commit('register/setFormIsChanged', false)
        })
    }
}
</script>

<style lang="scss" scoped>
.width-650 {
    max-width: 650px;
}

.download-docs-btn{
    width: 132px;
    height: 32px;
    font-size: 12px;
    line-height: 16px;
}

.doc-title {
    max-width: 100%;
}

.no-type-doc {
    border-color: #E19700;
}

.attachedDocumentsBox {
    max-height: 50vh;
    width: 45vw;
    overflow: scroll;
}

.main-documents-list {
    max-height: 65vh;
    width: 45vw;
    overflow: scroll;
}

div.list-upload:first-child {
    margin-top: 0px !important;
}

span.list-upload:last-child {
    margin-bottom: 0px !important;
}
</style>
